/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Lifecycle state for an AI Agent assistance record.
 */
export enum EmployeeAssistanceStatus {
    OPEN = 'open',
    RESOLVED = 'resolved',
}
